import { APIResponse } from 'types/Request';
import { getCookie } from 'helpers';
import config from 'config';
import { Localidades } from 'types/Localidades';

export async function getLocalidades(partidoId: number | undefined): Promise<Localidades[] | undefined> {
  try {
    const url = new URL(`${ config.baseUrl }/localidades`);

    if (partidoId !== undefined) {
      url.searchParams.append('partido_id', partidoId.toString());
    }

    type Response = APIResponse<Localidades[]>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      return;
    }

    const content = await response.json() as Response;
    const { payload } = content;

    return payload;
  } catch (err) {
    throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las gráficas. ');
  }
}
